'use strict'

import http from './http-common'
import authHeader from './auth-header'

const getAll = (companyId) => {
  return http.axiosClient.get(`/troubleticketanswers?companyId=${companyId}`, {
    headers: authHeader()
  })
}

const get = (id) => {
  return http.axiosClient.get(`/troubleticketanswers/${id}`, { headers: authHeader() })
}

const create = (data) => {
  return http.axiosClient.post('/troubleticketanswers', data, { headers: authHeader() })
}

export default {
  getAll,
  get,
  create
}
